import { take } from "rxjs/operators";
import { SidebarTraits } from "../traits/sidebar-traits";
import { Channel } from "spyne";

export class ChannelSidebar extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_SIDEBAR";
    props.traits = [SidebarTraits];
    props.sendCachedPayload = true;

    super(name, props);
  }

  onRouteChangeEvent(e) {
    const { payload, srcElement } = e;
    // const {routeData, pathInnermost} = e.payload;
    // const {pageId} = routeData;
    // const revealSidebar = this.sidebar$getRevealSidebarValByPageId(pageId, pathInnermost);
    //console.log('on route change event is ',{revealSidebar, pageId,routeData, payload}, this.props.data);
    this.sidebar$getState(payload, srcElement);
  }

  onDataReceived(e) {
    const { payload } = e;

    //this.props.data =  this.sidebar$ConformSidebarData(payload);
    this.props.data = payload.spyneDocsData;

    this.getChannel("CHANNEL_ROUTE").subscribe(
      this.onRouteChangeEvent.bind(this),
    );
  }

  onRegistered() {
    this.getChannel("CHANNEL_SPYNE_DOCS_DATA")
      .pipe(take(1))
      .subscribe(this.onDataReceived.bind(this));
  }

  addRegisteredActions() {
    return [
      "CHANNEL_SIDEBAR_REVEAL_PANEL",
      "CHANNEL_SIDEBAR_HIDE_PANEL",
      "CHANNEL_SIDEBAR_NAVIGATION_EVENT",
    ];
  }

  onViewStreamInfo(obj) {
    let data = obj.props();
  }
}
